import React, { useEffect } from 'react';
import { injectIntl } from "react-intl";
import { inject, observer } from 'mobx-react';
import { Box } from '@mui/material';
import Picker from 'rmc-picker';
import 'rmc-picker/assets/index.css';
import styled from 'styled-components';


const PickerContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding-top: 24px;
  background: #fff;
`;

const PickerWrapper = styled(Box)`
  flex: 1;
  max-width: 120px;
  position: relative;
  
  .rmc-picker {
    height: 240px;
    overflow: hidden;
    position: relative;
    
    .rmc-picker-content {
      position: relative;
    }
    
    .rmc-picker-item {
      height: 48px !important;
      line-height: 48px !important;
      font-size: 16px;
      color: #666;
      transition: all 0.3s ease;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .rmc-picker-item-selected {
      font-weight: 600;
      font-size: 18px;
    }
    
    .rmc-picker-indicator {
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      height: 48px !important;
      margin-top: -24px !important;
      border-top: 1px solid #757575 !important;
      border-bottom: 1px solid #757575 !important;
      background: none !important;
      pointer-events: none;
      z-index: 1;
    }
  }
`;

const MobileDatePicker = ({ 
  intl,
  selectedYear, 
  selectedMonth, 
  onYearChange, 
  onMonthChange,
  minYear = 2023,
  maxYear = new Date().getFullYear()
}) => {
  // 년도 배열 생성
  const years = Array.from({ length: maxYear - minYear + 1 }, (_, i) => {
    const yearValue = minYear + i;
    return {
      value: yearValue,
      label: intl.formatMessage(
        { id: "year_label" },
        { year: yearValue }
      ),
    };
  });
  
  const months = Array.from({ length: 12 }, (_, i) => {
    const monthValue = i + 1;
    return {
      value: monthValue,
      label: intl.formatMessage(
        { id: "month_label" },
        { month: monthValue }
      ),
    };
  });

  const handleYearChange = (value) => {
    console.log('Year changed to:', value);
    onYearChange(parseInt(value));
  };

  const handleMonthChange = (value) => {
    console.log('Month changed to:', value);
    onMonthChange(parseInt(value));
  };

  // 컴포넌트 마운트 후 정렬 강제 조정
  useEffect(() => {
    const adjustAlignment = () => {
      const indicators = document.querySelectorAll('.rmc-picker-indicator');
      const items = document.querySelectorAll('.rmc-picker-item');
      
      indicators.forEach(indicator => {
        indicator.style.position = 'absolute';
        indicator.style.top = '50%';
        indicator.style.height = '48px';
        indicator.style.marginTop = '-24px';
        indicator.style.left = '0';
        indicator.style.right = '0';
        indicator.style.zIndex = '1';
      });
      
      items.forEach(item => {
        item.style.height = '48px';
        item.style.lineHeight = '48px';
        item.style.display = 'flex';
        item.style.alignItems = 'center';
        item.style.justifyContent = 'center';
      });
    };

    // 컴포넌트 렌더링 후 약간의 지연을 두고 조정
    const timer = setTimeout(adjustAlignment, 100);
    
    return () => clearTimeout(timer);
  }, [selectedYear, selectedMonth]);

  return (
    <PickerContainer>
      {/* 년도 선택기 */}
      <PickerWrapper>
        <Picker
          selectedValue={selectedYear}
          onValueChange={handleYearChange}
          itemHeight={48}
          visibleItemCount={5}
        >
          {years.map(year => (
            <Picker.Item key={year.value} value={year.value}>
              {year.label}
            </Picker.Item>
          ))}
        </Picker>
      </PickerWrapper>

      {/* 월 선택기 */}
      <PickerWrapper>
        <Picker
          selectedValue={selectedMonth}
          onValueChange={handleMonthChange}
          itemHeight={48}
          visibleItemCount={5}
        >
          {months.map(month => (
            <Picker.Item key={month.value} value={month.value}>
              {month.label}
            </Picker.Item>
          ))}
        </Picker>
      </PickerWrapper>
    </PickerContainer>
  );
};

export default injectIntl(
  inject(
    "languageStore"
  )(observer(MobileDatePicker))
);